import React from 'react';
import { useNavigate } from 'react-router';
import { Link } from '@naf-simba/elements-links';
import { Text, TextVariant } from '@naf/text';
import { GridCol } from '@naf/grid';
import StA from '@styles/articles/StyledArticle';
import BenefitsList from '../../../../components/benefits-list/BenefitsList';
import * as S from './RelatedBenefits.styles';

type RelatedBenefitsProps = {
  relatedContent: [];
};

// This component is still used in LocalArticles.
// We should update to use NewRelatedBenefits but the response is different from the api so we need to update the benefit card component.
const RelatedBenefits = ({ relatedContent }: RelatedBenefitsProps) => {
  const navigate = useNavigate();
  const handleLinkClick = () => {
    const pathArr = window?.location?.pathname.split('/');
    const parentPath = pathArr?.slice(0, pathArr.length - 2).join('/'); // remove /fordeler/<benefit>
    navigate(`${parentPath}?tab=benefits`);
  };

  return (
    <S.StyledGridRow>
      <GridCol s="12" m="12" l="12" xl="12">
        <StA.ReadMoreHRLine />
        <S.ReadMoreWrapper>
          <Text tag="h2" variant={TextVariant.Header3}>
            Relevante fordeler
          </Text>
          {/* eslint-disable-next-line jsx-a11y/anchor-is-valid -- Link used as a non-navigating action */}
          <Link text="Se alle medlemsfordeler" variant="secondary" onClick={handleLinkClick} />
        </S.ReadMoreWrapper>
        <BenefitsList benefitItems={relatedContent} size="standard" />
      </GridCol>
    </S.StyledGridRow>
  );
};

export default RelatedBenefits;
